<template>
<div class="cookie-button-component">
  <v-btn
    fab
    elevation="2"
    aria-label="Manage cookie consent"
    :ripple="false"
    @click="onManageConsent"
  >
    <v-icon>fa-2x fa-solid fa-cookie-bite</v-icon>
  </v-btn>
</div>
</template>

<script>
export default {
  methods: {
    onManageConsent() {
      this.$emit('onManageConsent');
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../legacy/scss/lib';

.cookie-button-component {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1000;

  padding: 24px;

  background: transparent;

  @include slideInFromBottom();

  .v-btn {
    background: theme-palette(secondary, 400);
  }

  v-icon {
    color: rgba(0, 0, 0, 0.87);
    padding-left: 3px;
  }
}
</style>
